export default __webpack_public_path__ + "static/media/add-bx.0056e41e.svg";